import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sc-flyout StudentChoiceNavBarMenuGroup" }
const _hoisted_2 = ["aria-expanded", "expanded"]
const _hoisted_3 = { class: "sc-flyout-button-text" }
const _hoisted_4 = { class: "sc-menu" }
const _hoisted_5 = { class: "sc-menu-items" }
const _hoisted_6 = ["href"]

import { ref } from "vue";
import { JumpToMenuLink } from "@/types/jumpto-menu";


export default /*@__PURE__*/_defineComponent({
  __name: 'FlyoutMenu',
  props: {
    title: {},
    items: {}
  },
  setup(__props: any) {

const props = __props;

const jumpToMenuOpen = ref<boolean>(false);

function toggleJumpToMenu() {
  jumpToMenuOpen.value = !jumpToMenuOpen.value;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "sc-flyout-button",
      "aria-haspopup": "true",
      "aria-expanded": jumpToMenuOpen.value,
      expanded: jumpToMenuOpen.value,
      onClick: toggleJumpToMenu
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title || ""), 1),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "icon-down-open-big" }, null, -1))
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["sc-flyout-menu", { open: jumpToMenuOpen.value }])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (link) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "sc-link link sc-menu-link",
              key: link.linkText
            }, [
              (!link.externalLink && !link.href)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: link.to
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(link.linkText), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: link.href || ''
                  }, null, 8, _hoisted_6))
            ]))
          }), 128))
        ])
      ])
    ], 2)
  ]))
}
}

})